import { Section } from '@policygenius/dif-ts-types';

const militaryServiceSchema: Section = {
  nodeType: 'SECTION',
  urn: 'urn:pg:interview:section:continue-online-military',
  content: 'Military service',
  rules: { operation: '=', field: 'children.all.valid', value: true },
  presentationRules: {
    question_insured_military_current_station: {
      field: 'question_insured_military_service.value',

      value: 'currently',
      operation: '=',
    },
    section_previous_current: {
      operation: 'OR',
      value: [
        {
          field: 'question_insured_military_service.value',
          value: 'currently',
          operation: '=',
        },
        {
          field: 'question_insured_military_service.value',
          value: 'previously',
          operation: '=',
        },
      ],
    },
    section_previous_current_intends: {
      operation: 'OR',
      value: [
        {
          field: 'question_insured_military_service.value',
          value: 'currently',
          operation: '=',
        },
        {
          field: 'question_insured_military_service.value',
          value: 'previously',
          operation: '=',
        },
        {
          field: 'question_insured_military_service.value',
          value: 'intends_to',
          operation: '=',
        },
      ],
    },
  },
  children: [
    {
      nodeType: 'QUESTION',
      questionType: 'SINGLE_CHOICE',
      urn: 'urn:pg:interview:question:insured-military-service',
      dataPoint: {
        urn: 'urn:pg:data-point:insured-military-service',
        dataType: 'text',
      },
      content:
        'Have you ever been an active duty service member of the U.S. Armed Forces including the Reserves or National Guard? Or do you intend to become a member?',
      choices: [
        { value: 'never', displayText: 'Never' },
        {
          value: 'previously',
          displayText: 'Previously (Discharged or Retired)',
        },
        { value: 'currently', displayText: 'Currently' },
        { value: 'intends_to', displayText: 'Intends to' },
      ],
      rules: { field: 'value.present', value: true, operation: '=' },
    },
    {
      nodeType: 'QUESTION',
      questionType: 'TEXT',
      urn: 'urn:pg:interview:question:insured-military-current-station',
      dataPoint: {
        dataType: 'text',
        urn: 'urn:pg:data-point:insured-military-current-station',
      },
      content: 'Current station of duty',
      rules: { field: 'value.present', value: true, operation: '=' },
    },
    {
      nodeType: 'SECTION',
      urn: 'urn:pg:interview:section:previous-current-intends',
      content: '',
      rules: { operation: '=', field: 'children.all.valid', value: true },
      children: [
        {
          nodeType: 'QUESTION',
          questionType: 'TEXT',
          urn: 'urn:pg:interview:question:insured-military-dates-or-service',
          dataPoint: {
            dataType: 'text',
            urn: 'urn:pg:data-point:insured-military-dates-or-service',
          },
          content: 'Dates of service (year ranges are fine)',
          rules: { field: 'value.present', value: true, operation: '=' },
        },
        {
          nodeType: 'QUESTION',
          questionType: 'TEXT',
          urn: 'urn:pg:interview:question:insured-military-branch',
          dataPoint: {
            dataType: 'text',
            urn: 'urn:pg:data-point:insured-military-branch',
          },
          content: 'Branch of service',
          rules: { field: 'value.present', value: true, operation: '=' },
        },
      ],
    },
    {
      nodeType: 'SECTION',
      urn: 'urn:pg:interview:section:previous-current',
      content: '',
      rules: { operation: '=', field: 'children.all.valid', value: true },
      children: [
        {
          nodeType: 'QUESTION',
          questionType: 'TEXT',
          urn: 'urn:pg:interview:question:insured-military-pay-grade',
          dataPoint: {
            dataType: 'text',
            urn: 'urn:pg:data-point:insured-military-pay-grade',
          },
          content: 'Pay grade (current or at time of discharge or retirement)',
          rules: { field: 'value.present', value: true, operation: '=' },
        },
        {
          nodeType: 'QUESTION',
          questionType: 'TEXT',
          urn: 'urn:pg:interview:question:insured-military-rank',
          dataPoint: {
            dataType: 'text',
            urn: 'urn:pg:data-point:insured-military-rank',
          },
          content: 'Rank (current or at time of discharge or retirement)',
          rules: { field: 'value.present', value: true, operation: '=' },
        },
        {
          nodeType: 'QUESTION',
          questionType: 'TEXT',
          urn: 'urn:pg:interview:question:insured-military-duties',
          dataPoint: {
            dataType: 'text',
            urn: 'urn:pg:data-point:insured-military-duties',
          },
          content: 'Duties',
          rules: { field: 'value.present', value: true, operation: '=' },
        },
        {
          nodeType: 'QUESTION',
          questionType: 'TEXT',
          urn: 'urn:pg:interview:question:insured-military-mobilization-category',
          dataPoint: {
            dataType: 'text',
            urn: 'urn:pg:data-point:insured-military-mobilization-category',
          },
          content: 'Mobilization category (current or at time of discharge or retirement)',
          rules: { field: 'value.present', value: true, operation: '=' },
        },
        {
          nodeType: 'QUESTION',
          questionType: 'TEXT',
          urn: 'urn:pg:interview:question:insured-military-foreign-assignments',
          dataPoint: {
            dataType: 'text',
            subtype: 'long_text',
            urn: 'urn:pg:data-point:insured-military-foreign-assignments',
          },
          content: 'Please list the locations of your foreign assignment(s).',
          rules: { field: 'value.present', value: true, operation: '=' },
        },
      ],
    },
  ],
};

export default militaryServiceSchema;
